import { createPortal } from 'react-dom'

/**
 * Renders modal / dialog overlays into <body> instead of inline in the page tree.
 *
 * Why: every full-screen overlay is `position: fixed`, but when it's rendered inside `.app-main`
 * (which establishes a stacking context via `position: relative; z-index: 1`) it is trapped below
 * the mobile top bar (`.app-sidebar`, `z-index: 10`). The bar then paints over the overlay's top,
 * cropping the dialog's title/header with no way to reach it. Portaling to <body> lifts the overlay
 * out of that stacking context so it covers the whole viewport, top bar included. The overlays' own
 * CSS handles vertical scrolling/centering (see `align-items: safe center` + `overflow-y: auto`).
 */
export default function ModalPortal({ children }: { children: React.ReactNode }) {
  if (typeof document === 'undefined') return null
  return createPortal(children, document.body)
}
